import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, InteractionType, KeyValues10, KeyValues3, KeyValues5, LocalService, PageKey, Status, StatusWithId, Wrappers10, Wrappers5 } from 'src/service/local.service';

@Component({
  selector: 'app-create-no-config-bill',
  templateUrl: './create-no-config-bill.component.html',
  styleUrl: './create-no-config-bill.component.scss'
})
export class CreateNoConfigBillComponent {
  lstSectionConfigKeys: string[] = ["billing"]; maxBodyHeight = 0;
  businessId: string = ''; ctryCode: string = ''; interactionType = 0; billingId: string = ''; focusInputType = FocusInputType;

  source: Wrappers10; isOpenPopupConfig = false;
  data: KeyValues10; suggestions: KeyValues3[] = []; selectedSuggestionIndex: number = -1;

  get total(): number {
    if (!this.source.items || this.source.items.length === 0) {
      return 0;
    }
    let sum = 0;
    for (const item of this.source.items) {
      const price = parseFloat(item.v2?.toString() || '0');
      const qty = parseFloat(item.v3?.toString() || '0');
      const itemTotal = price * qty;
      if (!isNaN(itemTotal)) {
        sum += itemTotal;
      }
    }
    return parseFloat(sum.toFixed(2));
  }

  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private billingManagementService: BillingManagementService, private router: Router, private cdr: ChangeDetectorRef) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      name: 'name_' + this.htmlId,
      qty: 'qty_' + this.htmlId,
      price: 'price_' + this.htmlId,
      add: 'add_' + this.htmlId,
      print: 'print_' + this.htmlId,
      new_bill: 'new_bill_' + this.htmlId,
      settings: 'settings_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;
      this.billingId = routeParams.id;

      this.configurationManagementService.ensurePageActions(PageKey.CreateNoConfigureBill);

      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId, false, this.interactionType == InteractionType.User ? routeParams.businessId : '');
        this.ctryCode = routeParams.ctryCode;
        this.businessId = routeParams.businessId ? routeParams.businessId : '';
        this.onInitiate();
      }
    });
  }

  onInitiate() {
    this.onReset();
    this.onLoad();
  }

  onLoad() {
    this.billingManagementService.getNoConfigBilling(this.billingId).subscribe((result: Wrappers10) => {
      this.source = result;
      this.localService.tokenNumber = this.source.content.v2;
    });
  }

  ngOnDestroy(): void {
    this.localService.tokenNumber = '';
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(20);
    this.cdr.detectChanges();
  }

  onAdd() {
    if (!(this.data.v3 && this.data.v4)) {
      return;
    }

    this.billingManagementService.createNoConfigBilling(this.data).subscribe(result => {
      if (result.status == Status.Success) {
        if (this.billingId == '0') {
          this.router.navigate(['/create-no-config-bill' + this.localService.basicParamsString, this.businessId, result.value]);
        } else {
          this.source.items.push({
            key: result.id,
            v1: this.data.v2,
            v2: this.data.v3,
            v3: this.data.v4
          } as KeyValues10);
          this.onReset();
        }
      }
    });
  }

  onAddNewBill() {
    this.router.navigate(['/create-no-config-bill' + this.localService.basicParamsString, this.businessId, '0']);
  }

  onReset() {
    this.data = {
      key: this.billingId,
      v1: this.businessId,
      v2: '',
      v3: null,
      v4: null
    } as KeyValues10;

    this.suggestions = [];
    this.selectedSuggestionIndex = -1;

    this.localService.onFocusNextInput(this.elementIds.name, FocusInputType.TextBox);
  }

  onDelete(key: string) {
    if (this.source.items && key) {
      this.billingManagementService.deleteNoConfigBillingItem(this.billingId, key).subscribe((result: StatusWithId) => {
        if (result.status == Status.Success) {
          this.source.items = this.source.items.filter(item => item.key !== key);
        }
      });
    }
  }

  getItemTotal(item: KeyValues5): number {
    if (!item) {
      return 0;
    }
    const price = parseFloat(item.v2?.toString() || '0');
    const qty = parseFloat(item.v3?.toString() || '0');
    const val = price * qty;
    return isNaN(val) ? 0 : parseFloat(val.toFixed(2));
  }

  onGetSuggestion() {
    this.selectedSuggestionIndex = -1;
    const data = {
      v1: this.data.v2,
      v2: this.businessId
    } as KeyValues3;
    this.billingManagementService.getNoConfigBillingSuggestion(data).subscribe(result => {
      this.suggestions = result;
      if (this.suggestions && this.suggestions.length > 0) {
        this.selectedSuggestionIndex = 0;
      } else {
        this.selectedSuggestionIndex = -1;
      }
    });
  }

  onSelectSuggestion(item: KeyValues3) {
    this.data.v2 = item.v2;
    this.data.v3 = parseFloat(item.v3?.toString() || '0');
    this.suggestions = [];
    this.selectedSuggestionIndex = -1;
    this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
  }

  onNameKeydown(event: KeyboardEvent) {
    if (!this.suggestions || this.suggestions.length === 0) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.localService.onFocusNextInput(this.elementIds.price, FocusInputType.TextBox);
      }
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.selectedSuggestionIndex = (this.selectedSuggestionIndex + 1) % this.suggestions.length;
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.selectedSuggestionIndex = (this.selectedSuggestionIndex - 1 + this.suggestions.length) % this.suggestions.length;
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (this.selectedSuggestionIndex >= 0 && this.selectedSuggestionIndex < this.suggestions.length) {
        this.onSelectSuggestion(this.suggestions[this.selectedSuggestionIndex]);
      } else {
        this.localService.onFocusNextInput(this.elementIds.price, FocusInputType.TextBox);
      }
    } else if (event.key === 'Escape') {
      this.suggestions = [];
      this.selectedSuggestionIndex = -1;
    }
  }

  onSettingsClosed(event: any) {
    if (event && event.data) {
      this.source.settings = event.data;
    }
  }

  isPrintReceipt = false;
  printContent = '';
  onPrint() {
    const htmlDataSettings = this.source.settings;
    const isTwoLines = htmlDataSettings?.isSelected == true;

    let itemsHtml = '';
    if (this.source && this.source.items) {
      this.source.items.forEach(item => {
        const name = item.v1 || '';
        const price = parseFloat(item.v2?.toString() || '0').toFixed(2);
        const qty = parseFloat(item.v3?.toString() || '0').toFixed(2);
        const amount = this.getItemTotal(item).toFixed(2);

        if (isTwoLines) {
          itemsHtml += `
            <div style="margin-bottom: 8px;">
              <div style="word-break: break-all;">${name}</div>
              <div style="display: flex; font-size: 0.9em; color: #555;">
                <span style="width: 35%; padding-left: 10px; box-sizing: border-box; text-align: left;">${price}</span>
                <span style="width: 20%; text-align: right;">${qty}</span>
                <span style="width: 45%; text-align: right;">${amount}</span>
              </div>
            </div>
          `;
        } else {
          itemsHtml += `
            <div style="display: flex; font-size: 0.9em; margin-bottom: 8px;">
              <span style="width: 40%; text-align: left; word-break: break-all;">${name}</span>
              <span style="width: 20%; text-align: right;">${price}</span>
              <span style="width: 15%; text-align: right;">${qty}</span>
              <span style="width: 25%; text-align: right;">${amount}</span>
            </div>
          `;
        }
      });
    }

    let headerHtml = '';
    if (isTwoLines) {
      headerHtml = `
        <div style="font-size: 0.9em;">
          <div style="word-break: break-all;">Item Name</div>
          <div style="display: flex; font-size: 0.9em; color: #555;">
            <span style="width: 35%; padding-left: 10px; box-sizing: border-box; text-align: left;">Price</span>
            <span style="width: 20%; text-align: right;">Qty</span>
            <span style="width: 45%; text-align: right;">Amount</span>
          </div>
        </div>
      `;
    } else {
      headerHtml = `
        <div style="font-size: 0.9em; display: flex;">
          <span style="width: 40%; text-align: left; word-break: break-all;">Item Name</span>
          <span style="width: 20%; text-align: right;">Price</span>
          <span style="width: 15%; text-align: right;">Qty</span>
          <span style="width: 25%; text-align: right;">Amount</span>
        </div>
      `;
    }

    const tokenNumber = this.source?.content?.v2 || '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const month = months[now.getMonth()];
    const year = now.getFullYear();
    let hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedDateTime = `${day}-${month}-${year} ${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;

    const beforeHeaderDiv = htmlDataSettings.v1 ? `
      <div style="text-align: center; margin-bottom: 5px;">${htmlDataSettings.v1}</div>
      <div style="border-top: 1px dashed #000; margin: 8px 0;"></div>
    ` : '';

    this.printContent = `
      <html>
        <head>
          <title>Print Bill</title>
          <style>
            @media print {
              body { margin: 0; font-family: monospace; }
            }
            body { font-family: monospace; font-size: ${htmlDataSettings.v3}px; line-height: ${htmlDataSettings.v5}px; color: #000; }
          </style>
        </head>
        <body>
          <div style="width: ${htmlDataSettings.v4}mm; margin: 0;">
            ${beforeHeaderDiv}
            <div style="font-size: 0.85em; margin-bottom: 5px; line-height: 1.2;">
              ${tokenNumber ? `<div>Token: ${tokenNumber}</div>` : ''}
              <div style="text-align: right;">${formattedDateTime}</div>
            </div>
            <div style="border-top: 1px dashed #000; margin: 8px 0;"></div>
            ${headerHtml}
            <div style="border-top: 1px dashed #000; margin: 8px 0;"></div>
            <div>
              ${itemsHtml}
            </div>
            <div style="border-top: 1px dashed #000; margin: 8px 0;"></div>
            <div style="display: flex; justify-content: space-between;">
              <span>Total:</span>
              <span>${this.total.toFixed(2)}</span>
            </div>
            <div style="border-top: 1px dashed #000; margin: 8px 0;"></div>
            <div style="text-align: center; margin-top: 5px;">${htmlDataSettings.v2}</div>
          </div>
        </body>
      </html>
    `;

    this.isPrintReceipt = true;
  }

  onPrintedReceipt() {
    this.isPrintReceipt = false;
  }
}
